/**
 * CSRF constants — presence-only model.
 *
 * The BFF's :class:`CsrfMiddleware`
 * (``packages/meridian_bff/src/meridian_bff/_csrf.py``) requires
 * the header ``X-Meridian-CSRF: 1`` on every state-changing
 * request (POST / PUT / PATCH / DELETE). The protection comes from
 * the fact that cross-origin HTML forms cannot set custom headers,
 * and cross-origin ``fetch()`` triggers a CORS preflight which the
 * BFF's allow-list controls (REQ-AUTH-041). The header VALUE is a
 * fixed sentinel — there is no cookie / session-bound token — per
 * the BFF docstring's OWASP "BFF pattern with sticky session
 * cookies" rationale (see ``_csrf.py`` lines 7-27).
 *
 * Header name + sentinel value mirror the BFF-side constants
 * (``CSRF_HEADER_NAME`` / ``CSRF_HEADER_VALUE``); kept here so the
 * UI imports them from one canonical location.
 */

export const CSRF_HEADER_NAME = "X-Meridian-CSRF";
export const CSRF_HEADER_VALUE = "1";
